/**
 *
 * BreadCrumbItem
 *
 */

import ReturnIcon from './img/keyboard-return.svg'

/* eslint-disable vars-on-top, no-unneeded-ternary */

function BreadCrumbItem(props) {
  const { isBackIcon, nextIconPath, style, children, isNextIcon } = props

  return (
    <span>
      {isBackIcon === true ? <img className="bread-crumb-back" src={ReturnIcon} alt="back" /> : ''}
      <a className="bread-crum-link" href={nextIconPath} style={{ ...style }} title={children}>
        {children ? children : ''}
      </a>
      {isNextIcon === true ? <span className="bread-crumb-next" /> : ''}
    </span>
  )
}

export default BreadCrumbItem
